import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/about.scss";

function About() {
  return (
    <div className="about-page">
      <Header />

      <main className="about-main">
        {/* Section 1: Hero Banner */}
        <section className="hero-section">
          <img
            src="/brand/pets-community.svg"
            alt="Pets at the heart of Petoutlet"
            className="full-width-image"
          />
        </section>

        {/* Section 2: The Petoutlet Story */}
        <section className="story-section container">
          <h2 className="section-title">The Petoutlet Story</h2>
          <div className="story-content">
            <p>
              Petoutlet is an independent pet-supplies store focused on useful,
              approachable products for everyday life with dogs and cats. We
              bring together play, feeding, storage, travel, shelter, and litter
              essentials in one straightforward collection.
            </p>
            <p>
              Our work starts with the routines pet families know well: keeping
              food fresh, making travel more comfortable, encouraging active
              play, and simplifying cleanup. Those practical needs guide how we
              select and describe every item offered through Petoutlet.
            </p>
            <p>
              Pets are part of the family, so clear information and responsible
              care matter. We aim to present useful product details, sensible
              sizing guidance, and reminders that help pet parents choose and
              use products with confidence.
            </p>
            <p>
              Our collection spans dog and cat toys, feeding and watering, food
              storage, carriers, shelters, litter care, and other everyday
              essentials under the Petoutlet name.
            </p>

            <h3 className="subsection-title">Our Why</h3>
            <ul className="bullet-list">
              <li>
                To enrich the lives of families by cultivating the bond between
                people &amp; their pets.
              </li>
            </ul>

            <h3 className="subsection-title">Our Vision</h3>
            <ul className="bullet-list">
              <li>
                Families everywhere trust us more than any other company to
                enhance the well-being of their pets at every step of their
                adventure.
              </li>
            </ul>

            <h3 className="subsection-title">Petoutlet Core Values</h3>
            <ul className="bullet-list values-list">
              <li>
                <strong>CARE IN PRACTICE</strong>
                <br />
                We focus on practical choices that support pets and the people
                who care for them.
              </li>
              <li>
                <strong>KEEP IMPROVING</strong>
                <br />
                We listen to questions and feedback, then use them to make the
                shopping experience clearer and more useful.
              </li>
              <li>
                <strong>ACT RESPONSIBLY</strong>
                <br />
                We describe products honestly, protect customer information,
                and take responsibility for resolving problems.
              </li>
              <li>
                <strong>SAFETY FIRST</strong>
                <br />
                We encourage suitable sizing, supervised play, regular product
                inspection, and responsible everyday use.
              </li>
            </ul>
          </div>
        </section>

        {/* Section 3: Our Promise */}
        <section className="promise-section">
          <div className="promise-content">
            <div className="promise-left">
              <h2>Our Promise</h2>
              <p>
                Our promise is simple: present practical pet products clearly,
                support customers when questions arise, and keep the needs of
                pets at the center of our decisions. We aim to make each visit
                easy to understand—from choosing a size through delivery and
                after-sales support.
              </p>
            </div>
            <div className="promise-right">
              <img src="/img/petoutlet-15-angle.png" alt="Petoutlet cat scratcher lounge" />
            </div>
          </div>
        </section>

        {/* Section 4: Environmental Stewardship */}
        <section className="environmental-section container">
          <h2 className="section-title">Environmental Stewardship</h2>
          <p className="env-desc">
            We consider material use, durability, and packaging when reviewing
            products. Our goal is to favor practical products built for repeated
            use and to reduce unnecessary packaging where we can. We will only
            publish specific environmental claims when they can be supported by
            reliable product or supplier information.
          </p>

          <div className="stats-container">
            <div className="stat-item">
              <img src="/brand/materials.svg" alt="Thoughtful materials" />
            </div>
            <div className="stat-item">
              <img src="/brand/durability.svg" alt="Made for everyday use" />
            </div>
            <div className="stat-item">
              <img src="/brand/packaging.svg" alt="Less unnecessary packaging" />
            </div>
          </div>
        </section>

        {/* Section 5: The Faces & Paws of Petoutlet */}
        <section className="faces-section">
          {/* We assume a4.webp contains the title and images based on the provided files */}
          <div className="faces-ribbon">
            <h2>PETS AT THE HEART OF PETOUTLET</h2>
          </div>
          <img
            src="/brand/pets-community.svg"
            alt="Pets at the heart of Petoutlet"
            className="full-width-image"
          />
        </section>
      </main>

      <Footer />
    </div>
  );
}

export default About;
